import AUTH_TYPES from './types';

function login(username: string, password: string) {
	return {
		type: AUTH_TYPES.LOGIN,
		payload: { username, password },
	};
}

function logout() {
	return {
		type: AUTH_TYPES.LOGOUT,
	};
}

function successLogin(data: any) {
	return {
		type: AUTH_TYPES.SUCCESS_LOGIN,
		payload: { data },
	};
}
function loginFailed() {
	return {
		type: AUTH_TYPES.LOGIN_FAILED,
	};
}

function me() {
	return {
		type: AUTH_TYPES.ME,
	};
}

const authActions = {
	login,
	logout,
	successLogin,
	loginFailed,
	me,
};

export default authActions;
